"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledNavigationButton = exports.StyledContainer = exports.Header = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _NavigationButton = _interopRequireDefault(require("./components/NavigationButton"));
var _constants = require("./constants");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var Header = exports.Header = _styledComponents["default"].div.withConfig({
  displayName: "styles__Header",
  componentId: "sc-ujlv-0"
})(["font-size:", "px;line-height:", "px;font-weight:500;color:var(--black);"], function (_ref) {
  var $isMobile = _ref.$isMobile;
  return $isMobile ? 18 : 22;
}, function (_ref2) {
  var $isMobile = _ref2.$isMobile;
  return $isMobile ? 22 : 26;
});
var StyledContainer = exports.StyledContainer = _styledComponents["default"].div.withConfig({
  displayName: "styles__StyledContainer",
  componentId: "sc-ujlv-1"
})(["position:relative;display:flex;flex-direction:column;gap:", "px;.swiper-container{position:initial;", "}.swiper-button-disabled{visibility:hidden;}"], function (_ref3) {
  var $isMobile = _ref3.$isMobile;
  return $isMobile ? 8 : 16;
}, function (_ref4) {
  var $isMobile = _ref4.$isMobile;
  return $isMobile ? (0, _styledComponents.css)(["width:100%;overflow:clip;overflow-clip-margin:8px;"]) : (0, _styledComponents.css)(["width:calc(100% - ", "px * 2);"], _constants.NAV_BUTTON_SIZE);
});
var StyledNavigationButton = exports.StyledNavigationButton = (0, _styledComponents["default"])(_NavigationButton["default"]).withConfig({
  displayName: "styles__StyledNavigationButton",
  componentId: "sc-ujlv-2"
})(["position:absolute;z-index:1;bottom:calc(", "px / 2);transform:translateY(50%);", ""], _constants.SWIPER_HEIGHT, function (_ref5) {
  var type = _ref5.type;
  return type === 'prev' ? (0, _styledComponents.css)(["left:0;"]) : (0, _styledComponents.css)(["right:0;"]);
});